import { makeStyles } from '@material-ui/styles'
import { ArrowRightAltRounded } from '@mui/icons-material'
import { ButtonBase, Card, Stack, Typography, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { BsFileEarmarkArrowDown } from 'react-icons/bs'
import spreadsheet from '../../../../../utils/spreadsheet'
import { ExpensesIcon, InvoiceIcon, ProfitIcon, WomanIcon } from '../../../../atoms/icons'
import Modal from '../../../../molecules/Modal'
import { Button as CustomButton, Input } from '../../../../styled'
import Header from './Header'
import { getHeaders, getList } from './logList'
import PageSkeleton from './Skeleton'
import DataTable from './Table'

export default function Main() {

    const [loading, setLoading] = useState(true)
    const [modalOpen, setModalOpen] = useState(false)

    useEffect(()=>{

        setTimeout(()=>{
            setLoading(false)
        }, 1000)

    },[])

    const handleOnHeaderButtonClick =()=>{
        setModalOpen(modalOpen ? false : true)
    }

    const handleOnExport = ()=>{

        let salesHistory = getList()
        let objKeys: (string|number)[][] = []

        salesHistory.forEach((history)=>{
            const arr = Object.values(history)
            objKeys.push(arr)
        })

        const aoa = [
            getHeaders(),
            ...objKeys
        ]

        spreadsheet.aoaToSpreadSheet(aoa, "Inventory logs")
        setModalOpen(false)
        
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >
            <Header handleOnHeaderButtonClick={handleOnHeaderButtonClick} />

            {
                loading ? <PageSkeleton /> : <Content />
            }

            <Modal
                title="Export inventory logs"
                subtitle="Select time range to export data"
                visible={modalOpen}
                setVisibility={setModalOpen}
            >
                <Box
                >
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Start Date:</Typography>
                            <Input type="date" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">End Date:</Typography>
                            <Input type="date" />
                        </Stack>
                    </Stack>

                    <Box
                        sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
                    >
                        <CustomButton 
                            startIcon={<BsFileEarmarkArrowDown />} 
                            variant="contained" 
                            color="secondary" 
                            disableElevation={true}
                            onClick={handleOnExport}
                        >
                            <Typography  color="primary" sx={{fontSize:"13px"}} >Download</Typography>
                        </CustomButton>
                    </Box>

                </Box>
            </Modal>

        </Stack>
    )

}

function Content(){

    const theme = useTheme()

    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "normal",
            fontSize: "14px",
            outline: "none"
        }
    })

    const classes = useStyles()

    return(
        <Stack
            direction="column"
            spacing={2}
        >

            <Stack direction="row" spacing={2} >

                <Card variant="outlined" sx={styles.cardMin}>

                    <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                        <Stack direction="row" spacing={2} >
                            <div
                                style={{
                                    width: "18%",
                                    // height: "50px",
                                    padding: "0.5rem",
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    borderRadius: "3px"
                                }}
                            >
                                <ProfitIcon />
                            </div>

                            <Typography textAlign="left" >
                                <Typography color={grey[500]}>Total Profit</Typography>
                                <Typography variant="h6" > GH₵ 1.2K</Typography>
                            </Typography>

                        </Stack>

                        <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                            <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                            <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                <ArrowRightAltRounded htmlColor={grey[500]} />
                            </ButtonBase>

                        </Stack>

                    </Stack>
                    
                </Card>

                <Card variant="outlined" sx={styles.cardMin} >
                    <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                        <Stack direction="row" spacing={2} >
                            <div
                                style={{
                                    width: "18%",
                                    // height: "50px",
                                    padding: "0.5rem",
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    borderRadius: "3px"
                                }}
                            >
                                <InvoiceIcon />
                            </div>

                            <Typography textAlign="left" >
                                <Typography color={grey[500]}>Today</Typography>
                                <Typography variant="h6" > GH₵ 1.2K</Typography>
                            </Typography>

                        </Stack>

                        <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                        <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                        <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                            <ArrowRightAltRounded htmlColor={grey[500]} />
                        </ButtonBase>

                        </Stack>

                    </Stack>
                </Card>

                <Card variant="outlined" sx={styles.cardMin} >
                    <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                        <Stack direction="row" spacing={2} >
                            <div
                                style={{
                                    width: "18%",
                                    // height: "50px",
                                    padding: "0.5rem",
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    borderRadius: "3px"
                                }}
                            >
                                <ExpensesIcon />
                            </div>

                            <Typography textAlign="left" >
                                <Typography color={grey[500]}>Total Expenses</Typography>
                                <Typography variant="h6" > GH₵ 1.2K</Typography>
                            </Typography>

                        </Stack>

                        <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                            <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                            <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                <ArrowRightAltRounded htmlColor={grey[500]} />
                            </ButtonBase>

                        </Stack>

                    </Stack>
                </Card>

                <Card variant="outlined" sx={styles.cardMin} >
                    <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                        <Stack direction="row" spacing={2} >
                            <div
                                style={{
                                    width: "18%",
                                    // height: "50px",
                                    padding: "0.5rem",
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    borderRadius: "3px"
                                }}
                            >
                                <WomanIcon />
                            </div>

                            <Typography textAlign="left" >
                                <Typography color={grey[500]}>Best Shopkeeper</Typography>
                                <Typography variant="h6" > Adwoa Fosu</Typography>
                            </Typography>

                        </Stack>

                        <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                            <Typography color={grey[500]} fontSize="14px" fontWeight="light" >View employee performance</Typography>

                            <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                <ArrowRightAltRounded htmlColor={grey[500]} />
                            </ButtonBase>

                        </Stack>

                    </Stack>
                </Card>


            </Stack>

            <Box className={classes.content} >

                <Stack
                    sx={{height: "100%"}}
                    direction="column"
                    spacing={2}
                >

                    <DataTable 
                        title="Inventory logs"
                        tableBodyData={getList()}
                        tableHeadData={getHeaders()}
                        handleItemClick={()=>{}}
                    />

                </Stack>

                
            </Box>

        </Stack>
    )

}

const styles = {

    cardMin:{
        flex: 1, 
        borderRadius: "4px", 
        backgroundColor: 'primary.main',
        // backgroundColor: 'primary.dark',
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        padding: "1rem"
    },

}